// extracted by mini-css-extract-plugin
export default {"app__error":"PageNotFound_app__error__hFwsQ","error__center":"PageNotFound_error__center__OxPnd"};